import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/kit-dinamico',
  alias: ['/sistema/reportesbi/kit-dinamico/Index'],
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['121'],
  cita: 'Areas/ReportesBI/Controllers/KitDinamicoController.cs',
} satisfies RutaProd;
